$(function() {

  $('.shop-Slider_Slider').slick({
    autoplay: false,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '27%'
  });

}());
